import { css, SerializedStyles, useTheme } from '@emotion/react';
import React from 'react';
import { UpsunTheme } from '@upsun/react-component-library/src/themes';

type InvertImageProps = {
  src: string,
  alt?: string
  css?: SerializedStyles | SerializedStyles[]
};

const InvertImage : React.FC<InvertImageProps> = ({ src, alt, ...props }) => {
  const theme = useTheme() as UpsunTheme;

  const imgStyles = css`
    filter: invert(${theme.name === "light" ? 1 : 0});
  `;

  return (
    <img src={src} css={imgStyles} alt={alt || ""} {...props} />
  );
};

export default InvertImage;